import { Card, CardContent, CardProps, makeStyles, Typography, useTheme } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'
import { CardActionProps } from '../cardActions/cardActions'
import { CardBottom } from '../cardBottom/cardBottom'
import { CardTop } from '../cardTop/cardTop'
import { CardWithTransition } from '../cardWithTransition/CardWithTransition'
import { styles } from './cardInfo.styles'

export interface CardInfoProps extends CardProps {
  className?: string
  isLoading?: boolean
  withTransition: boolean
  info: Map<string, string> | undefined
  displayInfoKeys?: boolean
  avatarIcon?: JSX.Element
  title: string | undefined
  subtitle?: string
  titleVariant?: 'primary' | 'secondary'
  headerActions?: React.ReactNode // header actions are more generalistic
  footerActions?: CardActionProps[] // footer actions are buttons
}

export const CardInfo: React.FC<CardInfoProps> = ({
  className,
  isLoading,
  withTransition,
  info,
  displayInfoKeys = false,
  avatarIcon,
  title,
  subtitle,
  titleVariant = 'primary',
  headerActions,
  footerActions,
  ...props
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const { component, ref, ...cardContentProps } = props

  const CardInfoContent: React.FC = () => (
    <>
      <CardTop
        title={title}
        subtitle={subtitle}
        titleVariant={titleVariant}
        avatarIcon={avatarIcon}
        action={headerActions}
      />
      {isLoading ? (
        <>
          <Skeleton />
        </>
      ) : (
        <CardContent className={classes.cardContent} {...cardContentProps}>
          {info && info.size > 0
            ? [...info].map(([key, value], idx) => (
                <Typography key={`${key}-${idx}`} variant="body2" className={classes.description}>
                  {displayInfoKeys ? `${key}: ${value}` : `${value}`}
                </Typography>
              ))
            : ''}
        </CardContent>
      )}

      <CardBottom actions={footerActions} />
    </>
  )
  return (
    <>
      {withTransition ? (
        <CardWithTransition
          show={true}
          raised
          className={`${classes.card} ${className || ''}`}
          {...props}
        >
          <CardInfoContent />
        </CardWithTransition>
      ) : (
        <Card raised className={`${classes.card} ${className || ''}`} {...props}>
          <CardInfoContent />
        </Card>
      )}
    </>
  )
}
